import { Splide } from '@splidejs/splide';
export const initNewsSlider = () => {
    const mainEl = document.querySelector('#main-carousel');
    const thumbEl = document.querySelector('#thumbnail-carousel');
    if (!mainEl || !thumbEl)
        return;
    const main = new Splide(mainEl, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
    });
    const thumbnails = new Splide(thumbEl, {
        fixedWidth: 100,
        gap: 10,
        rewind: true,
        pagination: false,
        isNavigation: true,
        breakpoints: {
            600: {
                fixedWidth: 60,
                fixedHeight: 44,
            },
        },
    });
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
};
